export default {"src":"/_next/static/media/pair-1.865ef23c.svg","height":356,"width":501,"blurWidth":0,"blurHeight":0};